var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
    'ui button',
    _vm.customClass,
    _vm.colorClass,
    _vm.position,
    { 'icon': _vm.classIcon },
    { 'labeled ': _vm.title != '' },
    { disabled: _vm.disabled },
    { loading: _vm.loading } ],attrs:{"type":"button"},on:{"click":_vm.click}},[(_vm.classIcon)?_c('i',{class:_vm.classIcon}):_vm._e(),_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }